import { useEffect, useState } from "react";
import style from "./Sorter.module.scss";
import cn from "classnames";

export type SorterItem = {
  label: string,
  value: string
};

export function Sorter({
  currentValue,
  onChange,
  listValue
}: {
  currentValue: SorterItem["value"];
  onChange: (value: SorterItem) => void;
  listValue: {
    label: string,
    value: string
  }[]
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    function handleClick(e: any) {
      if (!e.target.closest("." + style.container)) {
        setIsOpen(false);
      }
    }

    document.documentElement.addEventListener("click", handleClick);

    return () => {
      document.documentElement.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div className={cn(style.container, isOpen && style.open)}>
      <button
        className={style.button}
        onClick={() => {
          setIsOpen((state) => !state);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="11"
          viewBox="0 0 15 11"
          fill="none"
        >
          <path
            d="M1 1H14"
            stroke="#1b1b1d"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.4375 5.16455H11.5625"
            stroke="#1b1b1d"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.6875 9.3291H8.3125"
            stroke="#1b1b1d"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className={"max-md:hidden"}>Сортувати</span>
        <svg
          className={cn("max-md:hidden", isOpen && "rotate-[180deg]")}
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M5.50503 9.49497C5.77839 9.76834 6.22161 9.76834 6.49497 9.49497L10.9497 5.0402C11.2231 4.76683 11.2231 4.32362 10.9497 4.05025C10.6764 3.77689 10.2332 3.77689 9.9598 4.05025L6 8.01005L2.0402 4.05025C1.76684 3.77689 1.32362 3.77689 1.05025 4.05025C0.776885 4.32362 0.776885 4.76684 1.05025 5.0402L5.50503 9.49497ZM5.3 8L5.3 9L6.7 9L6.7 8L5.3 8Z"
            fill="#1b1b1d"
          />
        </svg>
      </button>
      <div className={style.listCols}>
        {
          listValue.map(item => (
            <button
              key={item.value}
              className={cn(
                style.colName,
                currentValue === item.value && style.colName_active,
              )}
              onClick={() => {
                onChange(item);
              }}
            >
              {item.label}
            </button>
          ))
        }
      </div>
    </div>
  );
}
